// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"7bbf4c72","3511":"7bbf4c72","5388":"7bbf4c72","6566":"7bbf4c72","7071":"7bbf4c72","9245":"84555cd5","9450":"7bbf4c72"}[chunkId] + ".chunk.css";
};